import React from "react";
import Footer from "../footer";
import { MainContainer } from "../login/styles";

const Page404 = () => {
  return (
    <div>
      <MainContainer>Page is not found</MainContainer>
      <Footer></Footer>
    </div>
  );
};

export default Page404;
